import React, { Component } from 'react'
import CacheKeys from '../../cache/CacheKeys'
import CacheManager from '../../cache/CacheManager'
import AccountCreatePageUI from './AccountCreatePageUI.js'

class AccountCreatePageSF extends Component {
  constructor(props) {
    super(props)
    this.state = {
      messageList: null,
      errorList: null,
      stripeApiKey: null,
    }
  }

  render() {
    return (
      <AccountCreatePageUI
        context={this.props.context}
        messageList={this.state.messageList}
        errorList={this.state.errorList}
        stripeApiKey={this.state.stripeApiKey}
      />
    )
  }

  componentDidMount() {
    let context = this.props.context
    this.getStripeApiKey(context)
    this.getMessages(context)
  }

  getStripeApiKey(context) {
    let cacheManager = new CacheManager({
      resource: '/api/stripe/key',
      cacheKey: CacheKeys.StripeApiKey(),
      callback: this.getStripeApiKeyCallback,
      ttlInSecs: 3600
    })
    cacheManager.getObject2(context)
  }

  getStripeApiKeyCallback = (response) => {
    this.setState({stripeApiKey: response.publicKey})
  }

  getMessages(context) {
    let arr = [
      'c_create_account',
      'c_create',
      'c_cancel',
      'c_account_name',
      'c_country',
      'c_plan',
      'c_credit_card',
      'c_required_field',
      'c_create_account_tip',
      //
      'c_n_projects',
      'c_billed_daily',
      'c_billed_weekly',
      'c_billed_monthly',
      'c_billed_yearly',
      'c_trial_remaining',
      'c_1_day',
      'c_n_days',
    ]
    let keys = arr.join(',')

    let cacheManager = new CacheManager({
      resource: `/api/pub/messages/${keys}/locale/${context.locale}`,
      cacheKey: CacheKeys.Messages('pg_acc_create', context.locale),
      callback: this.getMessagesCallback,
      ttlInSecs: 3600
    })
    cacheManager.getObject2(context)
  }

  getMessagesCallback = (response) => {
    this.setState({messageList : response.messageList})
  }
}

export default AccountCreatePageSF
